import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Input component with forwarded ref
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.type - Input type
 * @param {boolean} props.error - Whether the input has an error
 * @param {React.Ref} ref - Forwarded ref
 */
const Input = React.forwardRef(({ className, error, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        !props.readOnly
          ? error
            ? "border-red-500 focus-visible:outline-none" // No ring styles on error
            : "border-input focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          : "outline-none focus:outline-none",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
